import { Modal } from 'react-bootstrap';
import { ConfirmModalProps } from './confirmModal.types';

export function ConfirmModal({
	show,
	onCancel,
	onDismiss,
	title,
	body,
}: ConfirmModalProps) {
	return (
		<Modal show={show} animation onHide={onCancel}>
			<Modal.Header>
				<h5 className='modal-title' id='Dismiss Modal'>
					{title}
				</h5>
				<div onClick={onCancel}>
					<span className='font-20 cursor-pointer'>&times;</span>
				</div>
			</Modal.Header>
			<Modal.Body>{body}</Modal.Body>
			<Modal.Footer>
				<button type='button' className='btn btn-secondary' onClick={onCancel}>
					No
				</button>
				<button type='button' className='btn btn-danger' onClick={onDismiss}>
					Yes
				</button>
			</Modal.Footer>
		</Modal>
	);
}
